module.exports = __webpack_public_path__ + "static/media/03-d-calendar.2c1a7ae9.png";